<template>
  <div>
    <van-list 
      v-model="loading"
      :finished="finished"
      finished-text="~没有更多了~"
      @load="getBookingsOrder"
      v-if="list.length != 0"
    >
      <li v-for='(item,index) in list'>
        <div class="center" v-if='item.bookingsCuringServiceBoList && item.bookingsCuringServiceBoList.length != 0'>
          <div @click='todetail(item)' class='bg_w'>
            <div class="order-info f24">
              <span>共{{item.goodsNumber}}件物品</span>
              <span class="status f24" v-show='!isActive(item) || item.paymentState == 10' >{{item.stateText}}</span>
            </div>
            <div class="server-container">
              <div v-for='(element,idx) in item.bookingsCuringServiceBoList'><booking-order-com :model='element'/></div>
            </div>
            <div class="pkg-info f28">
              <span>合计：<span class="f32">¥{{item.orderAmount}}</span></span>
              <!-- <span>共{{item.goodsNumber}}件物品</span> -->
            </div>
          </div>

          <div class="express-info" v-if='item.pickingWay != 0 && item.state != 119 && item.state != 129' v-show='!isActive(item)'>
            <div class="item">
              <div class="left f26">
                <span>邮寄方式</span><br/>
                <span class="tip f24" v-show='item.pickingWay == 10'>请包裹里附纸条留下主人的姓名和电话</span>
              </div>
              <div class="right f26">{{item.pickingWayText}}</div>
            </div>
            <div class="item shunfeng" v-if='item.pickingWay == 40 || item.pickingWay == 20'>
              <div class="left f26">
                <span>取件时间</span>
              </div>
              <div class="right f28" v-if='item.pickingDate && item.pickingWay == 40'>{{item.pickingDate.split(' ')[0]}} {{item.pickingStartTime}}-{{item.pickingEndTime}}</div>
              <div class="right f28" v-if='item.pickingDate && item.pickingWay != 40'>{{item.pickingDate}}</div>
            </div>
          </div>
        
          <div class="btn-wrap">
            <button class="btn-small-highlight-round btn" @click='sureMakeFn(item)' v-if='item.state == 10'>确认预约</button>
            <button class="btn-small-default-round btn" v-if='(item.paymentState == 20 || item.paymentState == 30) && isActive(item)' @click='addAdress(item)'>添加地址</button>
            <button class="btn-small-default-round btn" v-if='(item.paymentState == 20 || item.paymentState == 30) && item.state < 200 && isGoods(item)&&item.state!=10' @click='makeChange(item)'>修改预约</button>
            <button class="btn-small-highlight-round btn" v-if='item.paymentState == 10 && item.state != 900' @click='zhifu(item)'>立即支付</button>
            <button class="btn-small-default-round btn" v-if='showCancelBtn(item)' @click='concelShow(item.id)'>取消预约</button>

            <button class="btn-small-default-round btn" v-show='!isActive(item)' v-if='item.state == 100  && (item.paymentState == 20 || item.paymentState == 30) && !item.existBookingsOrderPackage && item.pickingWay != 40 && !item.groupRecordStatus' style='width:120px'  @click='$router.push({name:"fillExpress",query:{id:item.id}})' >填写快递单号</button>
            <button class="btn-small-default-round btn" v-show='item.groupRecordStatus && item.groupRecordStatus == 20' style='width:120px'  @click='invitation(item.groupRecordId)'>邀请好友拼团</button>
            <button class="btn-small-default-round btn" v-show='item.groupRecordStatus && item.groupRecordStatus == 30' style='width:120px'  @click='invitation(item.groupRecordId)'>查看拼团详情</button>
            <button class="btn-small-default-round btn" @click='lookExpress(item)' v-if='item.state == 220'>查看物流</button>
            <button class="btn-small-default-round btn" @click='makeAgain(item)' v-if='(item.state == 119 || item.state == 129)&&item.state!=10'>立即寄出</button>
            <button class="btn-small-default-round btn">
              <div  :id="'alldo'+item.id" style="position:absolute;width: 70px;height:40px;z-index:999;">
              </div>
            联系客服</button>
          </div>

          <!-- <button class="btn-small-default-round btn"  @click='contect'>联系客服</button> -->
        </div>

        <div class="center card" v-else >

          <div @click='todetail(item)'>
            <div class="order-info f24">
              <span>共{{item.goodsNumber}}件物品</span>
              <span class="status">{{item.stateText}}</span>
            </div>
            <!-- <div class="kefu-order"> -->
              <!-- <div class="kefu-order"><kefu-order-com :model='item'/></div> -->
              <div class="bottom_express"  v-show='!isActive(item)'>
                <div class="item">
                  <div class="left f26">
                    <span>邮寄方式</span><br/>
                    <span class="tip f24" v-show='item.pickingWay == 10'>请包裹里附纸条留下主人的姓名和电话</span>
                  </div>
                  <div class="right f26">{{item.pickingWayText}}</div>
                </div>
                <div class="item shunfeng" v-if='item.pickingWay == 40 || item.pickingWay == 20'>
                  <div class="left f26">
                    <span>取件时间</span>
                  </div>
                  <div class="right f28" v-if='item.pickingDate && item.pickingWay == 40'>{{item.pickingDate.split(' ')[0]}} {{item.pickingStartTime}}-{{item.pickingEndTime}}</div>
                  <div class="right f28" v-if='item.pickingDate && item.pickingWay != 40'>{{item.pickingDate}}</div>
                </div>
              </div>
            <!-- </div> -->
          </div>

          <div class="btn-wrap">
            <!-- <button class="btn-small-highlight-round" v-if='item.state == 10'>立即支付</button> -->
            <button class="btn-small-highlight-round btn"   @click='sureMakeFn(item)' v-if='item.state == 10'>确认预约</button>
            <button class="btn-small-default-round btn" v-if='(item.paymentState == 20 || item.paymentState == 30) && item.state < 200 && isGoods(item)&&item.state!=10' @click='makeChange(item)'>修改预约</button>
            <button class="btn-small-default-round btn" v-if='(concelButton(item.state) && !item.existBookingsOrderPackage) || item.state == 120 || item.state == 119 || item.state == 129 || item.state == 0' @click='concelShow(item.id)'>取消预约</button>
            <!-- <button class="btn-small-default-round btn" @click='contect'>联系客服</button> -->
            <button class="btn-small-default-round btn" v-if='item.state == 100 && (item.paymentState == 20 || item.paymentState == 30) && !item.existBookingsOrderPackage && item.pickingWay != 40' style='width:120px'  @click='$router.push({name:"fillExpress",query:{id:item.id}})' >填写快递单号</button>
            <button class="btn-small-default-round btn"  @click='lookExpress(item)' v-if='item.state == 220'>查看物流</button>
            <button class="btn-small-default-round btn" @click='makeAgain(item)' v-if='(item.state == 119 || item.state == 129)&&item.state!=10'>立即寄出</button>
        
          </div>

        </div>

      </li>
    </van-list>
    <div v-else>
      <img src='/images/order/noOrder.png' class='no-list'>
    </div>

    <van-popup position="bottom" v-model="expressShow">
      <div class='containerRefond f28 content'>
        <div class="title">物流信息</div>
        <div class="close" @click="expressShow = false"></div>
        <ul>
          <li class='arrive'>
            
            <span class='round'>
              收
            </span>
            <div class='text'>
              <div class='item_title'>包拯地址：包拯工作室 17526857604</div>
              <div class='dero'>天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）</div>
            </div>
     
          </li>
          <li v-for='(item,index) in expressLog' class='refundLi' :class='{active : !index }'>
            <div class='time'>
              <div>
                {{item.acceptDate}}
              </div>
              <div>
                {{item.acceptTime}}
              </div>
            </div>
            <span class='round'>
              <span></span>
            </span>
            <div class='text'>
              <div class='item_title'>{{item.remark}}</div>
              <div class='dero'>{{item.acceptAddress}}</div>
            </div>
     
          </li>
        </ul>
      </div>
    </van-popup>
    
    <div v-if='(againShow && shadowShow) || (adressShow && shadowShow)' class='shadow'></div>
    <van-popup position="bottom" v-model="againShow">
      <div class='containerRefond f28 contenter'>
        <div class="title">邮递方式</div>
        <div class="close" @click="againShow = false"></div>
        <select-address v-if='againShow' @showShade='shadowShow = true'  @hiddenShade='shadowShow = false' class='address' @changeType='changeType' :sendFrom='sendFrom' @changeAdr='changeAdr' @changeDate='changeDate'></select-address>
        <button class="primary again" @click='againSubmit()'>{{isChangeWay?'确定修改':'立即寄出'}}</button>
      </div>
    </van-popup>


    <van-popup position="bottom" v-model="adressShow">
      <div class='containerRefond f28 contenter'>
        <div class="title line-bottom" style='margin-top:0;padding-top:0' v-if='adressShow && !shadowShow'>收件地址</div>
        <div class="close" @click="adressShow = false" v-if='adressShow && !shadowShow'></div>
        <select-address1 v-if='adressShow' @showShade='shadowShow = true'  @hiddenShade='shadowShow = false' class='address' @changeType='changeType' :sendFrom='sendFrom1' @changeAdr='changeAdr1' @changeDate='changeDate'></select-address1>
        <button class="primary again" @click='addAdressSubmit()' v-if='adressShow && !shadowShow'>确定</button>
      </div>
    </van-popup>

    <!-- 确认预约弹窗 -->
      <div v-if='sureMakePopup && sureMakeShow' class='shadows'></div>
      <van-popup position="bottom" v-model="sureMakePopup">
        <div class='containerRefond f28 contenter'>
          <div class="close" @click="sureMakePopup = false"></div>
          <select-address2 v-if='sureMakePopup' :defultAdrId='clickItem.customerAddressBo.id' @showShade='sureMakeShow = true' :timeBox='timeBox' @hiddenShade='sureMakeShow = false' class='address' @changeAdr='changeAdr2' @changeDate='changeDate2'></select-address2>
          <button class="primary again" :disabled="shunfenDisabled" @click="submitMakeBtn">确认预约</button>
        </div>
      </van-popup>
      <!-- 确认预约弹窗 -->

  </div>
    
</template>

<script>
  import orderApi from '@/axios/order'
  import zhugeObj from '@/assets/js/track';
  import { Toast,Dialog } from 'vant';
  import getWXConfig from "@/assets/js/wx.config";
  export default {
    name: 'bookingOrders',
    components: {
      
    },
    data () {
      return {
        shunfenDisabled: false,
        sureMakePopup: false,
        sureMakeShow: false,
        newParams: {},
        timeBox: false,
        union_id: localStorage.getItem('unionId'),
        clickItem: {},

        adressShow : false,
        isChangeWay : false,
        shadowShow : false,
        loading: true,
        list : [],
        finished : false,
        pageCont : {
          current : 1,
          size	 : 5
        },
        loadMore : true,
        expressLog : [],
        expressShow : false,
        againShow : false,
        sendFrom1 : {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        },
        sendFrom : {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        },
        againId : '',
        addAdressCode : ''
      }
    },
    created () {
      this.getBookingsOrder();
    },  
    mounted () {
      zhugeObj.track({
        title : '订单预约-曝光',
      })
    },
    computed: {
      customerId() {
        return this.$store.state.customerId;
      }
    },
    methods: {
      sureMakeFn(item) {
        let detailTime = ''
        this.timeBox = false
        if(item.pickingStartTime) {
          detailTime = item.pickingDate + ' ' + item.pickingStartTime
        } else {
          detailTime = item.pickingDate + ' 23:59'
        }

        if(item.pickingWay==40) {

          if(new Date().getTime()>new Date(detailTime).getTime()) {
            this.timeBox = true
          }
          this.clickItem = item
          this.sureMakePopup = true;

        }else if(item.pickingWay==20||item.pickingWay==50) {
          console.log('',new Date().getTime()>new Date(detailTime).getTime())
          if(new Date().getTime()>new Date(detailTime).getTime()) {
            // 提示找客服改时间
            Toast('包拯上门取件时间已经失效，请您重新联系包拯客服确认时间')
            return
          }
          this.clickItem = item
          this.sureMakePopup = true;

        } else {
          this.submitMake(item)
        }
      },

      submitMake(item) {
        let params = {
          customerId: this.customerId,
          bookingsId: item.id,
          bookingsOrderCode: item.code,
          pickingWay: item.pickingWay,
          union_id: this.union_id
        }
        orderApi.sureMakeSubmit(params).then((res)=>{
          this.list = []
          this.pageCont.current = 1
          this.getBookingsOrder();
        })
      },

      submitMakeBtn() {
        let item = this.clickItem
        if(this.timeBox&&!this.newParams.pickingTime) {
          Toast('请选择上门取件时间')
          return
        }
        let params = {
          customerId: this.customerId,
          bookingsId: item.id,
          bookingsOrderCode: item.code,
          pickingWay: item.pickingWay,
          union_id: this.union_id
        }
        if(this.newParams.pickingDate) {
          params.pickingDate = this.newParams.pickingDate
        } else {
          params.pickingDate = item.pickingDate
        }

        if(this.newParams.pickingTime) {
          params.pickingTime = this.newParams.pickingTime
        } else {
          params.pickingTime = item.pickingTime
        }

        if(this.newParams.customerAddressId) {
          params.customerAddressId = this.newParams.customerAddressId
        } else {
          params.customerAddressId = this.userAddressId
        }
        this.shunfenDisabled = true
        orderApi.sureMakeSubmit(params).then((res)=>{
          this.timeBox = false
          this.sureMakePopup = false;
          this.list = []
          this.pageCont.current = 1
          this.getBookingsOrder();
          setTimeout(()=>{
            this.shunfenDisabled = false
          },1000)
        }).catch(()=>{
          this.shunfenDisabled = false
        })
      },
      changeDate2(data,time){
        this.newParams.pickingDate = data;
        this.newParams.pickingTime = time;
      },
      changeAdr2(element){
        this.newParams.customerAddressId = element.id;
      },
      setButton(){
        for(let obj of this.list){
          getWXConfig({path:'http://mi.baozheng.cc'})
          let dom = document.getElementById('alldo'+obj.id) //
          console.log('alldo'+obj.id)
          console.log(dom)
          let key = encodeURIComponent('订单信息已复制，可在输入框中粘贴后发给客服')
          let value = encodeURIComponent('订单号：'+obj.id)
          dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?key='+key+'&value='+value+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:80px;height:50px;position: relative;top:-10px;"></div></template></wx-open-launch-weapp>'
      
          let launchBtn = document.getElementById('launch-btn')
          if (!launchBtn) {
          return
          }
          launchBtn.addEventListener('launch', function (e) {
            zhugeObj.track({
                title: "个人中心-在线咨询-点击"
            });
          })
          launchBtn.addEventListener('error', function (e) {
          console.log('fail', e.detail)
          })
        }
      },
      addAdressSubmit(){
        
        orderApi.getOrderAddress({bookingsCode:this.addAdressCode}).then((res)=>{
          if(res){
             Dialog.confirm({
              title: '提示',
              message: '是否确定修改地址？',
              confirmButtonText : '确定',
              cancelButtonText : '取消'
            }).then(() => {
              // on confirm
              let params = {
                id : res.id,
                addressId : this.sendFrom1.customerAddressId
              }
              orderApi.patchOrderAddress(params).then((res)=>{
                Toast('修改成功');
                setTimeout(()=>{
                  this.adressShow = false;
                  this.parentsAction();
                },2000);
              
              })
            }).catch(() => {
              // on cancel
              this.adressShow = false;

            });
          }else{
            let params = {
              bookingsCode : this.addAdressCode,
              addressId : this.sendFrom1.customerAddressId
            }
            orderApi.orderAddress(params).then((res)=>{
              // this.adressShow = false;
              // this.parentsAction();
              Toast('添加成功');
              setTimeout(()=>{
                this.adressShow = false;
                this.parentsAction();
              },2000);
            })
          }
          
        })
       
      },
      addAdress(item){
        
        this.adressShow = true;
        this.addAdressCode = item.code;

      },
      // v-show='(!isActive(item) || item.paymentState == 10) && (item.groupRecordStatus && item.groupRecordStatus != 30)' v-if='(concelButton(item.state) && !item.existBookingsOrderPackage) || item.state == 120 || item.state == 119 || item.state == 129  || item.state == 0'
      showCancelBtn(item){
        //是否是囤货卷
        //是否是拼团
        //普通预约单
        if(this.isActive(item)){
          //囤货卷支付状态必须是10
          if(item.paymentState == 10){
            //900是预约单取消
            if(item.state == 900){
              return false
            }else{
              return true
            }
          }else{
            return false
          }
        }else if(item.groupRecordStatus){
          //拼团
          // if(item.groupRecordStatus != 30){
          //   return true;
          // }else{
            return false;
          // }
        }else{
          //普通预约单
          if(this.concelButton(item.state) && !item.existBookingsOrderPackage){
            return true;
          }else{
            if(item.state == 120 || item.state == 119 || item.state == 129  || item.state == 0){
              return true;
            }else{
              return false;
            }
          }
        }
      },
      invitation(id){
        zhugeObj.track({
          title : '预约——邀请好友拼团',
          content : {
            '邀请好友拼团' : '邀请好友拼团',
          }
        })
        this.$router.push({name:"teamDetail",query:{groupRecordId:id}})
      },
      isGoods(item){
        if(item.bookingsCuringServiceBoList){
          if(item.bookingsCuringServiceBoList[0]){
            if(item.bookingsCuringServiceBoList[0].classify == 10){
              return true;
            }else{
              return false;
            }
          }else{
            return false;
          }
        }else{
          return true;
        }
      },
      isActive(item){
        if(item.bookingsCuringServiceBoList){
          if(item.bookingsCuringServiceBoList[0]){
            if(item.bookingsCuringServiceBoList[0].classify == 20){
              return true;
            }else{
              return false;
            }
          }else{
            return false;
          }
        }else{
          return false;
        }
      },
      isTeam(item){
        if(item.bookingsCuringServiceBoList){
          if(item.bookingsCuringServiceBoList[0]){
            if(item.bookingsCuringServiceBoList[0].classify == 30){
              return true;
            }else{
              return false;
            }
          }else{
            return false;
          }
        }else{
          return false;
        }
      },
      againSubmit(){
        let params = {
          
        }
        params.pickingWay = this.sendFrom.sendType;
        params.bookingsOrderCode = this.againId;
        if(params.pickingWay == 40){
          params.pickingDate = this.sendFrom.pickingDate;
          params.pickingTime = this.sendFrom.pickingTime;
          params.customerAddressId = this.sendFrom.customerAddressId;
          
          //参数验证
          if(!params.customerAddressId){
              Toast('请选择地址');
              return;
          }

          if(!params.pickingDate){
              Toast('请选择上门时间');
              return;
          }
        }

        if(this.isChangeWay){
          console.log(params)
          orderApi.postWay(params).then((res)=>{
            this.againShow = false;
            this.parentsAction();
          })
          return;
        }
        

        orderApi.sendNow(params).then((res)=>{
          this.againShow = false;
          
          this.parentsAction();
        })
      },  
      changeDate(data,time){
        this.sendFrom.pickingDate = data;
        this.sendFrom.pickingTime = time;
      },
      changeAdr(element){

        this.sendFrom.customerAddressId = element.id;
      },
      changeAdr1(element){
        this.sendFrom1.customerAddressId = element.id;
      },
      changeType(index){
        this.sendFrom.sendType = index;
      },  
      makeChange(item){
        this.sendFrom = {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        }
        this.isChangeWay = true;
        this.againId = item.code;
        this.againShow = true;
      },  
      makeAgain(item){
        this.sendFrom = {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        }
        this.isChangeWay = false;
        this.againId = item.code;
        this.againShow = true;
      },  
      lookExpress(item){
        //code暂时写死
        console.log(item.code);
        orderApi.listRouteInfo(item.code).then((res)=>{
          this.expressShow = true;
          this.expressLog = res;
   
        })
      },
      zhifu(item){
        zhugeObj.track({
          title : '预约-点击立即支付',
          content : {
            '预约单ID' : item.id,
          }
        })
        //增加是否有结算单拦截代码        
        orderApi.unpaid().then((res)=>{
          
            if(!res){
          
              if(this.isActive(item) || this.isTeam(item)){
                this.$router.push({name:"pay",query:{id:item.code,type:'active'}})
              }else{
                this.$router.push({name:"pay",query:{id:item.code}})
              }
              
              return;
            }else{
           
                orderApi.settlementConcel(res.settlementCode).then(()=>{
                  if(this.isActive(item) || this.isTeam(item)){
                    this.$router.push({name:"pay",query:{id:item.code,type:'active'}})
                  }else{
                    this.$router.push({name:"pay",query:{id:item.code}})
                  }
                })
        
            }
        })
      },
      parentsAction(){
        this.list = [];
        this.pageCont = {
          current : 1,
          size : 5
        };
        this.loadMore = true;
        this.getBookingsOrder();
      },
      concelShow(id){
        this.$emit('concelShow',id);
      },
      //详情
      todetail(item){
        if(this.isActive(item) || this.isTeam(item)){
          return;
        }else{
          this.$router.push({name:'orderDetail',query:{id:item.id,type:1}})
        }
        
      },
      
      //联系客服按钮     
      contect(){
          this.$emit('contect');
      },
      //是否显示已取消按钮
      concelButton(type){
        if(type == 100 || type == 110 || type == 120){
          return true;
        }else{
          return false;
        }
      },
      getBookingsOrder(){
        if(this.loadMore){
          let params = {
            current : this.pageCont.current,
            size : this.pageCont.size,
          }
          this.loadMore = false;
          orderApi.getBookingsOrder(params).then((res)=>{
            console.log(res);
            this.loadMore = true;
            
            this.list = this.list.concat(...res.records || []);
            this.loading = false;
            setTimeout(()=>{
                this.setButton()    
            },1000)
            if(res.totalPage == this.pageCont.current || res.totalPage == 0){
              this.finished = true;
            }
            if(res.records.length == 0){
              this.finished = true;
            }

            this.pageCont.current ++;
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .card{
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
      padding-bottom: 1px;
  }
  .line-bottom{
  
    // margin-left: 40px;
    // margin-right: 40px;
    // padding-bottom: 20px;
    // line-height: 90px;
    // border-bottom:1px solid #EEEEEE;
    // font-size: 28px;
    // font-weight:500
  }

  .address_title{
      p{
          font-size: 36px;
          color:#4A4A4A;
          font-weight:600;
          margin-top: 40px;
      }
      &>div{
          margin-top: 20px;
          margin-bottom: 20px;
      }
  }

  .shadow{
    background-color: rgba(0,0,0,.7);;
    position: fixed;
    width: 100%;
    top:0;
    bottom: 0;
    left: 0;

  }
  .again{
    margin-bottom: 30px;
    margin-right: 30px;
    margin-top:50px;
    float: right;
  }
  .contenter{
    padding-left:0!important;
    padding-right:0!important;

    .title{
      padding-top:30px;
      margin-left: 40px;
      margin-bottom: 0!important;
    }
  }
  .arrive{
    border-left:1px dashed #7ADFDF!important;
    font-size: 12px!important;
    .item_title{
      margin-bottom: 10px!important;
      font-size:20px!important;
    }
    .round{
      background: #7ADFDF!important;
      border: none!important;
      color:#fff;
      font-size: 20px!important;
    }
  }
  .no-list{
    width:100%;
    margin-top: 300px;
  }
  .van-list{
    display: flex;
    align-items: center;
    flex-direction: column;

    li{
      width: 690px;

      border-radius:6px;
      margin-top: 30px;
      .center{
        .bg_w{
          background:rgba(255,255,255,1);
          box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
          padding-bottom: 1px;
        }
        &>div{
          padding: 0 30px;
        
        }
        .order-info{
          padding: 32px;
          padding-left:0;
          padding-right:0;
          display: flex;
          justify-content: space-between;
          border-bottom:1px solid #F6F6F6;
          font-size:24px; 
          // margin-bottom: 30px;
          .status{
            color: #F24949;
            font-size: 28px;
            font-weight:600;
          }
        }
        .server-container{
          padding-bottom:10px;
          border-bottom:1px solid #F6F6F6;
          &>div{
            margin-bottom: 20px;
            margin-top: 20px;
          }
          
        }
        .kefu-order{
          padding: 0;
        }
        .bottom_express{
 

          
          padding-top:24px;
          padding-bottom:24px;
          color:#666666;
          border-bottom:1px solid #FFFFFF;
          .item{
            display: flex;
            justify-content: space-between;
            line-height: 40px;
            .left{
              // color: $primary-color;
              .tip{
                display: inline-block;
                color: #999;
                margin-top:10px; 
              }
            }
            .right{
              color: #666;
            }
            &:last-child{
              // margin-bottom: 56px;
            }
          }
        }
        .express-info{
          // margin-top: 10px;
          background: #F8F8F8;
          
          padding-top:24px;
          padding-bottom:24px;
          color:#666666;
          border-bottom:1px solid #FFFFFF;
          .item{
            display: flex;
            justify-content: space-between;
            line-height: 40px;
            .left{
              // color: $primary-color;
              .tip{
                display: inline-block;
                color: #999;
                margin-top:10px; 
              }
            }
            .right{
              color: #666;
            }
            &:last-child{
              // margin-bottom: 56px;
            }
          }
        }
        .pkg-info{
          display: flex;
          flex-direction: row-reverse;
          align-items: flex-end;
          line-height: 40px;
          margin-top:20px;
          margin-bottom: 19px;
          span{
            margin-left: 10px;
          }
        }
        .btn-wrap{
          padding: 16px 0;
          padding-right:16px;
          display: flex;
          background: #F8F8F8;
          flex-direction: row-reverse;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          .btn-small-highlight-round{
            margin-left: 20px;
         

          }
          .btn{
            margin-left: 20px;
            background:rgba(255,255,255,1)!important;
            box-shadow:0px 0px 8px -4px rgba(0,0,0,0.06)!important;
            border:none;
          }
        }
      }
    }
  }
  .shunfeng{
    margin-top: 10px;
  }

  .active{
    color:#7ADFDF!important;
    span{
      color:#7ADFDF!important;
      
    }
    div{
       color:#7ADFDF!important;
    }
    .round{
      border: 1px solid #7ADFDF!important;
      span{
        background: #7ADFDF!important;
      }
    }
  }
  .containerRefond{
      padding: 30px;
      position: relative;
      padding-bottom:90px; 
      // padding-left:100px;
      .title{
        line-height: 40px;
        margin-bottom: 50px;
        font-weight:500; 
      }
      .close{
        width: 36px;
        height: 36px;
        position: absolute;
        top: 30px;
        right: 30px;
        background: url("/images/public/close.png") no-repeat center;
        background-size: 32px;
      }
      ul{
        padding-left: 100px;
        padding-top: 10px;
        max-height: 600px;
        overflow: scroll;
        li{

          line-height: 40px;
          margin-top: 60px;

          padding-left:40px;
          position: relative;
          border-left:1px solid #E4E4E4;

          .text{
            position: relative;
            top:-52px;
            color:#999999;
            font-size: 24px;
            .item_title{
              margin-bottom: 30px;
              font-size:28px;

            }
          }
          .time{
            position: absolute;
            top:-55px;
            left: -95px;
            font-size: 14px;
            color:#999999;
            line-height: 22px;

          }
          .round{
            width: 36px;
            height: 36px;
            display: inline-block;

            // background: #D2D2D2;
            border: 1px solid #D2D2D2;
            border-radius:50%; 
            position: absolute;
            left:-19px;
            top:-50px;
            text-align: center;
            span{
              width: 28px;
              height: 28px;
              background: #D2D2D2;
              display: inline-block;
              margin-top:4px;
         
              border-radius:50%;  
            }
          }
          time{
            float: right;
          }
        }
      }
  }
</style>
